export default __webpack_public_path__ + "static/media/App-banner-min.9282021a.jpg";